/* eslint-disable react/no-unstable-nested-components */
import React, {useState, useEffect} from 'react';
import {Row, Col, Input, Container, Button, Table} from "reactstrap";
import classnames from 'classnames';
import {useTranslation} from "react-i18next";
import {AcervoAPI, ConsultaAPI} from "../../../../shared/http-requests";
import {SpinnerConstructor} from "../../../../shared/components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from '@fortawesome/free-solid-svg-icons';
import Login from "../auth/Login";
import shortid from "shortid";
import {useDispatch} from "react-redux";
import {changeDadosProtocoloArmazem, changeSubmenuSelected} from "../../../../store/ducks/dadosAcervo";
import {SUB_MENU_MENSAGEM_ACERVO_FECHADO} from "../../consts";
import Axios from "axios";
import {APIHelper} from "../../../../shared/helpers";
import { AuthPersist } from '../../../../store/ducks/authPersist';
import { AuthSession } from '../../../../store/ducks/auth';
import { Store } from '../../../../store';

/**
 * @author Renan Salustiano <renan.salustiano@ter.grupomarista.org.br>
 * @param acervo
 * @returns {JSX.Element}
 * @constructor
 */
const AcervoFechado = ({acervo}) => {
    const {t} = useTranslation();

    const [dados, setDados] = useState(null);

    const [selectedBiblioteca, setSelectedBiblioteca] = useState(null);
    const [selectedVolume, setSelectedVolume] = useState(null);
    const [selectedTomo, setSelectedTomo] = useState(null);
    const [selectedParte, setSelectedParte] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [cestaArmazem, setCestaArmazem] = useState(false);
    const [loadingLogin, setLoadingLogin] = useState(false)
    const [displayCesta, setDisplayCesta] = useState(null);
    const [loadingCesta, setLoadingCesta] = useState(false)
    const dispatch = useDispatch();


    /**
     * Passa os dados da sessão para o state ao iniciar componente
     */
    useEffect( () => {
        if(!acervo){
            return;
        }

        const _cestaArmazem = localStorage.getItem('cesta_armazem');

        if(!_cestaArmazem){
            setCestaArmazem(null)
        }else{
            setCestaArmazem(JSON.parse(_cestaArmazem))
        }

    }, [acervo])


    /**
     * Busca os dados dos acervos na cesta pra montar a tabela com os dados atualizados
     */
    useEffect(() => {
        setLoadingCesta(true);

        if(![null, false].includes(cestaArmazem)){
          const requests =  cestaArmazem.map( ({codAcervo}) => {
               return ConsultaAPI.consulta({
                   termo_pesquisa: codAcervo,
                   coluna_um: 'INDICE_30',
                   search_id: shortid.generate(),
                   search_tab: 'pesquisa_geral',
               }).then((response) => {
                   const { data } = response;

                   if(data && data?.length){
                       return data[0];
                   }

                   return null;
               })
           })

           Promise.all(requests).then( (data) => {
               if(data){
                    setDisplayCesta(data);
               }

               setLoadingCesta(false);
           }).catch( () => {
               setLoadingCesta(false)
           })
       }else{
            setLoadingCesta(false)
            setDisplayCesta(null);
        }

    }, [cestaArmazem]);



    /**
     * Busca os dados do armazem
     */
    useEffect(() => {
        if (!acervo) return;
        buscarDadosArmazem();
    }, [acervo]);

    /**
     *
     * @param dados {{cod_biblioteca: string, volume: string, tomo: string, parte: string}}
     */
    const buscarDadosArmazem = (dados = {}) => {

        setLoading(true)

        const {
            cod_biblioteca = selectedBiblioteca,
            volume = selectedVolume,
            tomo = selectedTomo,
            parte = selectedParte
        } = dados;


        AcervoAPI.buscarDadosArmazem(acervo.cod_acervo, cod_biblioteca, tomo, parte, volume).then((response) => {
            const {data} = response;

            if (data) {
                const {
                    bibliotecas,
                    volumes,
                    tomos,
                    partes,
                    selected_biblioteca,
                    selected_volume,
                    selected_tomo,
                    selected_parte
                } = data;

                setSelectedBiblioteca(selected_biblioteca)
                setSelectedVolume(selected_volume)
                setSelectedTomo(selected_tomo)
                setSelectedParte(selected_parte)

                if(tomos?.length === 0 || partes?.length === 0 || volumes?.length === 0 || bibliotecas?.length === 0){
                    setError(true);
                }

                setDados({bibliotecas, volumes, tomos, partes});
            }

            setLoading(false)
        }).catch((error) => {
            console.error(error);
            setLoading(false)
            setError(true)
        });


    }



    /**
     * Adiciona o acervo atual á cesta
     */
    const hendleClickAdicionarACesta = () => {
        let newCestaArmazem = [{codAcervo: acervo.cod_acervo, codBiblioteca: selectedBiblioteca, volume: selectedVolume, tomo: selectedTomo, parte: selectedParte}];

        if (![false, null].includes(cestaArmazem)) {
            newCestaArmazem = [...cestaArmazem, {codAcervo: acervo.cod_acervo, codBiblioteca: selectedBiblioteca, volume: selectedVolume, tomo: selectedTomo, parte: selectedParte}]
        }

        localStorage.setItem('cesta_armazem', JSON.stringify(newCestaArmazem))
        setCestaArmazem(newCestaArmazem);
    }



    /**
     *
     * @param codAcervo
     */
    const handleClickRemoverAcervo = (codAcervo) => {

        if ([false, null].includes(cestaArmazem)) {
            localStorage.removeItem('cesta_armazem');
            return;
        }

        let newCestaArmazem = cestaArmazem.filter(ca => ca.codAcervo != codAcervo);

        if (newCestaArmazem.length === 0) {
            localStorage.removeItem('cesta_armazem');
            setCestaArmazem(null);
        } else {
            setCestaArmazem(newCestaArmazem)
            localStorage.setItem('cesta_armazem', JSON.stringify(newCestaArmazem))
        }

    }

    /**
     * Renderiza ou não botão de adicionar à cestaa
     */
    const renderizarBotao = () => {

        if (cestaArmazem === false) {
            return;
        }

        if (cestaArmazem !== null) {
            const acervoContido = cestaArmazem?.find(cm => cm.codAcervo == acervo.cod_acervo)

            if (acervoContido) {
                return;
            }
        }


        return !loadingCesta && (<Button
            onClick={() => hendleClickAdicionarACesta()}
            className="bkazul branco b-none sazul hover hpreto pad5 rad5 t10 r10 f770 s13"
        >
            {t('AdicionarCesta')}
        </Button>)
    }


    /**
     * grava os dados do armazem
     */
    const  handleClickEnviar = () => {
        if(cestaArmazem){
            setLoading(true);
            setLoadingCesta(true);
            AcervoAPI.gravarArmazem(cestaArmazem, selectedBiblioteca).then((response) => {
                const { data } = response;

                dispatch(changeDadosProtocoloArmazem(data));

                setCestaArmazem(null)
                localStorage.removeItem('cesta_armazem');

                dispatch(changeSubmenuSelected({
                    parent: 'acervo_fechado',
                    submenu: SUB_MENU_MENSAGEM_ACERVO_FECHADO,
                    name: 'Protocolo'
                }))

                setLoading(false);
                setLoadingCesta(false);
                Store.dispatch(AuthPersist.logout());
                Store.dispatch(AuthSession.logout());

            }).catch( (error) => {

                if (!Axios.isCancel(error)){
                    console.error(error)
                    APIHelper.tratarErro(error);
                }

                setLoading(false);
                setLoadingCesta(false);
            })
        }
    }

    return (<Row className="pad5 animated fadeIn">
        {dados !== null && (
            <Col
                xs="12"
                md="6"
                className="b-solid-right b-w1 b-tema40 "
            >
                {
                    loading && (
                        <Container>
                            <Row>
                                <Col
                                    xs="12"
                                    md={{size: 4, offset: 4}}
                                    className="mt-5 p-md-5 p-0"
                                >
                                    <div className="p-5 text-center animated fadeIn">
                                        <SpinnerConstructor
                                            visible
                                            showLabel
                                            height={80}
                                            width={80}
                                            className="apergamum"
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    ) || (<>
                        {
                            error && (<Col
                                xs="12"
                                md="6"
                                className="b-solid-right b-w1 b-tema40 text-center"
                            >
                                <div className="p-5 animated fadeIn">
                                    <FontAwesomeIcon
                                        icon="exclamation-triangle"
                                        className="laranja s20 r10"
                                    />
                                    <span className="laranja s17">
                                         Houve um erro...
                                    </span>
                                </div>
                            </Col>)
                        }

                        <Row className="b-w1 b-cinza2 b-solid-bottom pad5">
                            <Col md="12">
                                <label className="f500 cortxt s13">
                                    Para seguir com a solicitação preencha os dados a baixo.
                                </label>
                            </Col>
                        </Row>

                        <Row className="b-w1 b-cinza2 b-solid-bottom p-2 animated fadeIn">
                            <Col
                                md="3"
                                xs="12"
                                className="pb-md-0 pb-2"
                            >
                                <label className="f500 preto70 s13">
                                    {t('Biblioteca')} :
                                </label>
                            </Col>
                            <Col md="9" xs="12">
                                <Input
                                    type='select'
                                    onChange={e => {
                                        setSelectedBiblioteca(e.target.value)
                                        buscarDadosArmazem({cod_biblioteca: e.target.value, tomo: null, volume: null, parte: null})
                                    }}
                                    value={selectedBiblioteca}>
                                    {dados?.bibliotecas.map(({cod_biblioteca, desc_biblioteca}) => (
                                        <option  key={cod_biblioteca} value={cod_biblioteca}>{desc_biblioteca}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>

                        <Row className="b-w1 b-cinza2 b-solid-bottom p-2 animated fadeIn">
                            <Col
                                md="3"
                                xs="12"
                                className="pb-md-0 pb-2"
                            >
                                <label className="f500 preto70 s13">
                                    {t('Volume')} :
                                </label>
                            </Col>
                            <Col md="9" xs="12">
                                <Input
                                    type='select'
                                    onChange={e => {
                                        setSelectedVolume(e.target.value)
                                        buscarDadosArmazem({volume: e.target.value, tomo: null, parte: null})
                                    }}
                                    value={selectedVolume}>
                                    {dados?.volumes.map(({volume}) => (
                                        <option  key={volume} value={volume === 'Unico' ? 99999 : volume}>{volume === 'Unico' ? 'Único' : volume}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        <Row className="b-w1 b-cinza2 b-solid-bottom p-2 animated fadeIn">
                            <Col
                                md="3"
                                xs="12"
                                className="pb-md-0 pb-2"
                            >
                                <label className="f500 preto70 s13">
                                    {t('Tomo')} :
                                </label>
                            </Col>
                            <Col md="9" xs="12">
                                <Input
                                    type='select'
                                    onChange={e => {
                                        setSelectedTomo(e.target.value)
                                        buscarDadosArmazem({tomo: e.target.value, parte: null})
                                    }}
                                    value={selectedTomo}>
                                    {dados?.tomos.map(({tomo}) => (
                                        <option  key={tomo} value={tomo === 'Unico' ? 99999 : tomo}>{tomo === 'Unico' ? 'Único' : tomo}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        <Row
                            className="b-w1 b-cinza2 b-solid-bottom p-2 animated fadeIn"
                        >
                            <Col
                                md="3"
                                xs="12"
                                className="pb-md-0 pb-2"
                            >
                                <label className="f500 preto70 s13">
                                    {t('Parte')} :
                                </label>
                            </Col>
                            <Col md="9" xs="12">
                                <Input
                                    type='select'
                                    onChange={e => {
                                        setSelectedParte(e.target.value)
                                        buscarDadosArmazem({parte: e.target.value})
                                    }}
                                    value={selectedParte}>
                                    {dados?.partes.map(({parte}) => (
                                        <option  key={parte} value={parte === 'Unico' ? 99999 : parte}>{parte === 'Unico' ? 'Único' : parte}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                    </>)
                }

                <Row className="mt-3">
                    <Col md={{size: 10, offset: 1}} xs="12">
                        <Login
                            embedded
                            altRender={auth =>
                                auth && (
                                    <div className="text-center p-3 animated fadeIn">
                                        {loadingLogin && (
                                            <div>
                                                <SpinnerConstructor
                                                    height={40}
                                                    width={40}
                                                    className="preto70 mb-2"
                                                    visible
                                                />
                                                <span className="f300 preto80 s14">
                                                            {t('Aguarde')}...
                                                 </span>
                                            </div>
                                        ) || (
                                            <Col xs={'12'}>
                                                <Row className={'d-flex justify-content-center align-items-center'}>
                                                    {renderizarBotao()}

                                                    {
                                                        !loadingCesta && !loading && cestaArmazem && cestaArmazem?.length > 0 && (
                                                            <Button
                                                                className="btn-generic--primeiro ml-0"
                                                                onClick={handleClickEnviar}
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon="check"
                                                                    className="r10"
                                                                />
                                                                {t('Enviar')}
                                                            </Button>
                                                        )
                                                    }

                                                </Row>
                                            </Col>

                                        )}
                                    </div>
                                ) || (<Row>
                                    <Col xs={'12'}>
                                        <Row className={'d-flex justify-content-center align-items-center'}>
                                            {renderizarBotao()}
                                        </Row>
                                    </Col>
                                        <div className="pad10">
                                            <FontAwesomeIcon
                                                icon="exclamation-circle"
                                                className="laranja s14 r10"
                                            />
                                            <span className="preto90 s14">
                                                 {t('NecessarioFazerLoginSolicitacao',)}
                                            </span>
                                        </div>
                                      </Row>)
                            }
                        />
                    </Col>
                </Row>
            </Col>
        ) || (
            <Col
                xs="12"
                md="6"
                className="b-solid-right b-w1 b-tema40 text-center"
            >
                <div className="p-5 mt-3">
                    <SpinnerConstructor
                        visible
                        height={70}
                        width={70}
                        className="cortxt70 s20"
                    />
                </div>
            </Col>
        )}

        <Col md="6" sn={"12"} className="d-md-block  pt-3">
            <Row className="b-w1  pad5">
                <Col md="12" className="preto80 f500 s14">
                    <FontAwesomeIcon icon="angle-right" className="r10"/>
                    <span className="s15">
                        Cesta
                   </span>
                </Col>
            </Row>
            <Row className="b-w1">
                <Col md="12" className="preto60 f400 s12">
                    {
                        loadingCesta && (
                                <Row>
                                    <Col
                                        xs="12"
                                        md={{size: 4, offset: 4}}
                                        className="mt-5 p-md-5 p-0"
                                    >
                                        <div className="p-5 text-center animated fadeIn">
                                            <SpinnerConstructor
                                                visible
                                                showLabel
                                                height={80}
                                                width={80}
                                                className="apergamum"
                                            />
                                        </div>
                                    </Col>
                                </Row>

                        ) || displayCesta !== null &&
                        (<Table
                            responsive
                            className="s10 preto70 text-center"
                        >
                            <thead>
                            <tr>
                                <th className={'s10'}>{t('Acervo')}</th>
                                <th className={'s10'}>{t('Referencia')}</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {displayCesta.map(ca => (
                                <tr
                                    id={ca.cod_acervo}
                                    className={classnames({
                                        // 'bklaranja': (ca.cod_acervo == acervo.cod_acervo),
                                        // 'text-white': (ca.cod_acervo == acervo.cod_acervo)
                                    })}
                                    key={ca.cod_acervo}>
                                    <td className={'s10'}>
                                        {ca.cod_acervo}
                                    </td>
                                    <td className={'s10'}>
                                        {ca.referencia_sem_tag}
                                    </td>
                                    <td className={'s10'}>
                                        <button
                                            className="btn-generic--primeiro nao"
                                            title={t('Remover')}
                                            onClick={e => handleClickRemoverAcervo(ca.cod_acervo)}
                                        >
                                            <FontAwesomeIcon icon="trash-alt" />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>) ||
                        (<Row>
                            <p className="s14  cortxt60 m-auto">Nenhum material adicionado na cesta.</p>
                        </Row>)
                    }
                </Col>
            </Row>
        </Col>

        <Col md="12"/>
    </Row>)
}

export default AcervoFechado;
